export default {
  translation: {},
};
